<template>
  <ab-flow-base-cmp :movable="true" :block="block" class="pdf-generator-editor-cmp">

    <ab-flow-link-connector :block="block" type="input" class="ev-run" event="run"/>

    <q-card class="card">

      <q-card-section class="bg-blue-4 text-white q-py-sm">
        {{ title }}: {{ syncResponse ? 'sync' : 'async' }}
      </q-card-section>

    </q-card>

    <div class="results">
      <ab-flow-link-connector v-if="syncResponse" :block="block" type="output" event="pdf-url"/>
      <ab-flow-link-connector v-else :block="block" type="output" event="job-id"/>
      <ab-flow-link-connector :block="block" type="output" event="error"/>
    </div>

  </ab-flow-base-cmp>
</template>

<script>

import AbFlowBaseCmp from "ab-flow-designer/src/components/Designer/AbFlowBaseCmp";
import AbFlowLinkConnector from "ab-flow-designer/src/components/Designer/AbFlowLinkConnector";

export default {
  components: {AbFlowBaseCmp, AbFlowLinkConnector},
  inject: ['canvas'],
  props: ['block'],
  name: "PdfGeneratorEditorCmp",

  computed: {
    // Get the title property from the block
    title() {
      return this.block?.properties?.title || 'PDF generator';
    },
    // Get the syncResponse property from the block
    syncResponse() {
      return this.block?.properties?.syncResponse === 1;
    },
  },
}

</script>

<style lang="scss">

.pdf-generator-editor-cmp {
  position: relative;

  .card {
    max-width: 200px;
    word-wrap: break-word;
  }
  .ev-run {
    left: -12px;
    position: absolute;
    z-index: 1;
    top: calc(50% - 5px);
  }
  .results {
    right: -12px;
    position: absolute;
    z-index: 1;
    top: calc(50%);
    transform: translateY(-50%);
    display: flex;
    flex-direction: column;
    row-gap: 6px;
  }
}

</style>
